import { render } from "./BreadcrumbView.vue?vue&type=template&id=f04968b0"
import script from "./BreadcrumbView.vue?vue&type=script&lang=js"
export * from "./BreadcrumbView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__